var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5V3h-4V1a1 1 0 00-1-1H5a1 1 0 00-1 1v2H0v2h16zM6 2h4v1H6V2zm7 5v7H3V7H1v8a1 1 0 001 1h12a1 1 0 001-1V7h-2z",
    fill: "#797584"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 12V7h2v5H5zm4 0V7h2v5H9z",
    fill: "#797584"
  })));
}

export default SvgDelete;